import gql from "graphql-tag";

const appCenter = {
  userApps: gql`
    query userApps($user: String) {
      userApps(user: $user) {
        id
        name
        uri
        text
        code
        description
        tags
        icon
        department
        visible
        recommend
        rating
        rated
        system
        trait
        created
        dynamicAttributes
        template {
          id
          name
          text
          tags
        }
      }
    }
  `,

  userRecommendationApps: gql`
    query userRecommendationApps($user: String) {
      userRecommendationApps(user: $user) {
        id
        name
        uri
        text
        code
        description
        tags
        icon
        department
        recommend
        rating
        rated
        system
        created
        sort
        template {
          id
          name
          text
          tags
        }
        templateEntry {
          screens
          userFilters
        }
        userFiltersMatched
        blocks {
          name
          text
          userFiltersMatched
        }
      }
    }
  `,

  anonymityApps: gql`
    query anonymityApps($tenant: String!) {
      anonymityApps(tenant: $tenant) {
        text
        tags
        icon
        dynamicAttributes
        recommend
        trait
        visible
      }
    }
  `,

  // department

  
  // 记录用户点击收藏访问次数
  createAppOperationRecord: gql`
    mutation createAppOperationRecord(
      $user: String
      $record: AppOperationRecordInput!
    ) {
      createAppOperationRecord(user: $user, record: $record) {
        id
      }
    }
  `,
  // 记录用户点击取消收藏访问次数
  cancelAppCollect: gql`
    mutation cancelAppCollect($user: String, $app: String!) {
      cancelAppCollect(user: $user, app: $app) {
        id
      }
    }
  `,
  // 查询用户收藏列表
  userFavoriteApps: gql`
    query userFavoriteApps {
      userFavoriteApps {
        id
      }
    }
  `,
  //查询应用评价
  appReviews: gql`
    query appReviews($filter: AppReviewFilter) {
      appReviews(filter: $filter) {
        totalCount
      }
    }
  `,
  //查询我的评分及评价
  userAppReviews: gql`
    query userAppReviews($user: String, $filter: AppReviewFilter) {
      userAppReviews(user: $user, filter: $filter) {
        edges {
          cursor
          node {
            name
            rate
            text
            user {
              account
              openid
              text
            }
            created
            updated
          }
        }
        pageInfo {
          hasNextPage
        }
        totalCount
      }
    }
  `,
  //新增应用评价
  createAppReview: gql`
    mutation createAppReview($user: String, $review: AppReviewInput!) {
      createAppReview(user: $user, review: $review) {
        name
      }
    }
  `,
  //最近使用应用列表
  userRecentApps: gql`
    query userRecentApps($first: Int, $offset: Int) {
      userRecentApps(first: $first, offset: $offset) {
        id
        name
        uri
        text
        code
        description
        tags
        icon
        department
        recommend
        rating
        rated
        system
        created
        updated
      }
    }
  `,
  userNoLoginHotApps: gql`query anonymityHotApps($tenant: String!){
      anonymityHotApps(tenant: $tenant){
        id
        name
        uri
        text
        code
        description
        tags
        icon
        department
        trait
        recommend
        dynamicAttributes
      }
  }`,
  userHotApps: gql`
    query hotApps{
      hotApps{
        id
        name
        uri
        text
        code
        description
        tags
        icon
        department
        trait
        recommend
        rating
        rated
        system
        created
        updated
        dynamicAttributes
      }
    }
  `,
  appNoLoginTags: gql`query anonymityAppTags($tenant: String!, $filter: AppTagFilter){
    anonymityAppTags(tenant: $tenant, filter: $filter){
        id
        text
        icon
        sort
        updated
        parent
        visible
    
    }
  
  }`,
  //查询标签列表
  appTags: gql`
    query appTags($filter: AppTagFilter) {
      appTags(filter: $filter) {
        id
        text
        icon
        sort
        updated
        parent
        visible
      }
    }
  `,

  //tasks

  process: gql`
    query process($id: String, $entry: String, $system: String) {
      process(id: $id, entry: $entry, system: $system) {
        id
        name
        uri
        entry
        status
        create
        update
        priority
        tags
        rating
        review
        pendingTasks
        app {
          id
          code
          name
          uri
          tags
          icon
          department
          abbreviation
          description
          recommend
          palette
          rating
          rated
          system
        }
        owner {
          id
          account
          name
        }
        milestone {
          name
          percent
          status
        }
        milestones {
          name
          percent
          status
        }
        system {
          id
          name
        }
        tasks {
          id
          name
          actionUser {
            name
          }
          actionTime
          actionName
        }
      }
    }
  `,
  todo: gql`
    query tasks($cate: String!, $userId: String) {
      tasks(cate: $cate, userId: $userId) {
        name
        id
        assignTime
        uri
        actionName
        expireTime
        actions {
          code
          id
          name
        }
        process {
          id
          name
          uri
          tags
          entry
          create
          owner {
            id
            name
            account
          }
          app {
            name
            code
          }
          system {
            id
            name
          }
        }
      }
    }
  `,
  doing: gql`
    query processes(
      $cate: String!
      $userId: String
      $page: Int
      $size: Int
      $filter: ProcessFilter
    ) {
      processes(
        cate: $cate
        userId: $userId
        page: $page
        size: $size
        filter: $filter
      ) {
        totalCount
        edges {
          node {
            id
            name
            uri
            entry
            create
            pendingTasks
            update
            app {
              name
              code
            }
            system {
              id
              name
            }
            owner {
              name
            }
            milestone {
              name
              percent
              status
            }
          }
        }
      }
    }
  `,
  done: gql`
    query processes(
      $cate: String!
      $userId: String
      $page: Int
      $size: Int
      $filter: ProcessFilter
    ) {
      processes(
        cate: $cate
        userId: $userId
        page: $page
        size: $size
        filter: $filter
      ) {
        totalCount
        edges {
          node {
            id
            name
            uri
            entry
            create
            pendingTasks
            update
            app {
              name
              code
            }
            system {
              id
              name
            }
            owner {
              name
              account
            }
          }
        }
      }
    }
  `,
  cc: gql`
    query processes(
      $cate: String!
      $userId: String
      $page: Int
      $size: Int
      $filter: ProcessFilter
    ) {
      processes(
        cate: $cate
        userId: $userId
        page: $page
        size: $size
        filter: $filter
      ) {
        totalCount
        edges {
          node {
            id
            name
            uri
            entry
            create
            pendingTasks
			read
            update
            app {
              name
            }
            system {
              id
              name
            }
            owner {
              name
            }
          }
        }
      }
    }
  `,
  completed: gql`
    query processes(
      $cate: String!
      $userId: String
      $page: Int
      $size: Int
      $filter: ProcessFilter
    ) {
      processes(
        cate: $cate
        userId: $userId
        page: $page
        size: $size
        filter: $filter
      ) {
        totalCount
        edges {
          node {
            id
            name
            uri
            entry
            create
            pendingTasks
            update
            app {
              name
            }
            system {
              id
              name
            }
            owner {
              name
            }
            milestone {
              percent
            }
          }
        }
      }
    }
  `,

  mePoint: gql`query {
    me {
      name
    }
  }`,

  // palette
    //有权限看到的专题
    appProjects: gql`query userAppProjects {
      userAppProjects {
          id
          text
          released
          description
          snapshot
          background
          icon
          palette
          updated
          type
          sort
          paragraphs {
            apps {
              id
              text
              name
              sort
              tags
              code
              uri
              __typename
            }
            id
            title
            context
            sort
            subtitle
            __typename
          }
          __typename
        }
      }`,

    //未登录，通过appcenter_url拿场景
    anonymityAppProjects: gql`query anonymityAppProjects($tenant: String!) {
      anonymityAppProjects(tenant: $tenant) {
        id
        text
        description
        background
    }
  }`,

  appStat: gql`query appStatistics($filter: Map, $type: AppStatisticType!) {
    appStatistics(filter: $filter, type: $type) {
      code
      name
      value
    }
  }`,

  appAnonymityStat: gql`query anonymityAppStatistics($filter: Map, $type:AnonymityAppStatisticType!, $tenant:String!) {
    anonymityAppStatistics(filter: $filter, type: $type, tenant: $tenant) {
      value
      code
      name
    }
  }`,


  //应用详情
  app: gql`query app($id:String!){
    app(id:$id){
              abbreviation
              code
              contact
              department
              description
              dynamicAttributes
              telephone
              icon
              id
              kind
              name
              recommend
              tags
              text
              uri
            
    }
}`,

appStatistics: gql`query appStatistics($filter: Map, $type: AppStatisticType!) {
    appStatistics(filter: $filter, type: $type) {
      code
      name
      value
      __typename
    }
  }`,

  addlog: gql`mutation addLog($log: LogInput, $filter: Filter) {
    addLog(log: $log, filter: $filter) {
      attributes
      clientId
      device
      ip
      location
      metric
      moduleName
      moduleText
      openId
      principalName
      requestUrl
      tenantCode
      timestamp
      type
      userAgent
    }
  }
  `

};
export default appCenter;



// WEBPACK FOOTER //
// ./src/graphql/appCenter.js